import type { GQL_ID } from '@@partner:types:graphql'
import type { MenuItem, LinkType, MenuItemTranslation } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

export interface UpdateMenuItemInput {
  internal_name?: string
  title?: string
  image_file_id?: GQL_ID | null
  icon_code?: string
  icon_color?: string
  text_color?: string
  link_url?: string
  link_type?: LinkType
  bold?: boolean
  is_active?: boolean
  sort_order?: number
  i18n?: MenuItemTranslation[]
}

export interface UpdateMenuItemMutation {
  updateMenuItem: MenuItem
}

export interface UpdateMenuItemVariables {
  id: GQL_ID
  input: UpdateMenuItemInput
}

export const GQL_MUTATION_UPDATE_MENU_ITEM = gql`
  mutation updateMenuItem($id: ID!, $input: UpdateMenuItemInput!) {
    updateMenuItem(id: $id, input: $input) {
      id
      menu_id
      internal_name
      title
      image_file_id
      icon_code
      icon_color
      text_color
      link_url
      link_type
      bold
      is_active
      sort_order
      created_at
      updated_at
      
      image {
        url
      }
      
      translations {
        language_code
        title
      }
      
      i18n {
        language_code
        title
      }
    }
  }
`

export const useUpdateMenuItem = () =>
  useMutation<UpdateMenuItemMutation, UpdateMenuItemVariables>(GQL_MUTATION_UPDATE_MENU_ITEM)
